namespace('compass.hotel');

compass.hotel.RoomSharesWidget = compass.defineWidget(function RoomSharesWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var _numberOfShares = _settings.numberOfShares;
	var _roomShareInfo = _settings.roomShareInfo;

	var _labels = {
		first_name: {
			label: 'First Name',
			hint: 'A valid first name is required'
		},
		last_name: {
			label:  'Last Name',
			hint: 'A valid last name is required'
		},
		email: {
			label: 'Email Address',
			hint: 'A valid email address is required'
		}
	};


	var _setupControls = this.setupControls = function() {

	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		widgetElem.append(me.drawRoomSharesForm());
		_setupControls();
	};

	var sharesForm;
	this.drawRoomSharesForm = function() {
		var d = _d;
		sharesForm = d.div({
			className : 'roomSharesForm'
		}, me.drawShareRows(_settings.numberOfShares));

		return sharesForm;
	};

	var sharesArray = [];
	this.drawShareRows = function(numberOfRows) {
		var d = _d;
		for(var i = 0; i < numberOfRows; i++ ) {
			if(numberOfRows == 1) {
				sharesArray.push(me.drawOneShareRow(i + 1, _roomShareInfo[i]));
			} else {
				var _id = compass.generateId();
				sharesArray.push(
					d.fieldset({'ARIA-labelledby': _id}, d.div({className : 'shareHeader', id : _id }, "Person " + (i + 1)), me.drawOneShareRow(i + 1, _roomShareInfo[i]) )
				);
			}
		}
		return sharesArray;
	};

	this.drawOneShareRow = function(id, value) {
		var d = _d;
		/*We will probably move to storing all the page data in a JSON object and thus make
		 * having the id in the field name needless.  We can then just strip it out in the future when we make each row
		 * its own index of an array of data
		 */
		var shareInfo = { first_name: '', last_name: '', email: '', share_id: -1};
		var isReadOnly = false;
		if(!_.isEmpty(value)) {
			isReadOnly = true;
			shareInfo = {
				first_name: value.first_name,
				last_name: value.last_name,
				email: value.email,
				share_id: value.share_id
			};
		}

		return d.div({id : 'roomShare' + id, share_id: shareInfo.share_id, className:'roomShareRow'},
					[d.fieldLabelPair({
						className : 'firstName',
						label : 'First name:'
					},
					d.input({
						type : 'text',
						name : 'firstName',
						className : 'firstName firstNameInput',
						readonly: isReadOnly,
						value: shareInfo.first_name,
						'tabindex': '0',
						id: compass.generateId(),
						autocomplete: 'off',
						'data-parsley-error-message': _labels.first_name.hint,
						'data-parsley-required': 'false',
						'data-parsley-pattern': /[^\d\s\.\/\-]/  //Contains at least 1 letter
					})
					),
					d.fieldLabelPair({
						className : 'lastName',
						label : 'Last name:'
					},
					d.input({
						type : 'text',
						name : 'lastName',
						className : 'lastName lastNameInput',
						readonly: isReadOnly,
						value: shareInfo.last_name,
						'tabindex': '0',
						id: compass.generateId(),
						autocomplete: 'off',
						'data-parsley-error-message': _labels.last_name.hint,
						'data-parsley-required': 'false',
						'data-parsley-pattern': /[^\d\s\.\/\-]/  //Contains at least 1 letter
					})
					),
					d.fieldLabelPair({
						className : 'email',
						label : 'Email:'
					},
					d.input({
						type : 'text',
						name : 'email',
						className : 'email emailInput',
						readonly: isReadOnly,
						value: shareInfo.email,
						id: compass.generateId(),
						'tabindex': '0',
						'data-parsley-error-message': _labels.email.hint,
						'data-parsley-required': 'false',
						'data-parsley-type': 'email',
						autocomplete: 'off'})
					)]
		);
	};

	var changeSharesCount = function (new_count) {
		if (new_count > sharesArray.length) {
			for (var i = new_count, l = sharesArray.length; i > l; l++) {
				var share = me.drawOneShareRow(l+1).hide();
				sharesArray.push(share);
				sharesForm.append(share);
				share.slideDown(250);
			}
		} else if (new_count < sharesArray.length) {
			for (var i = new_count, l = sharesArray.length; i < l; l--) {
				var share = sharesArray.pop();
				share.slideUp(250, function () { share.remove(); });
			}
		}
		_numberOfShares = new_count;
	};

	this.grabValues = function() {
		var rows = me.find('.roomShareRow');
		var jsonValues = [];

		me.find('.roomShareRow').each(function() {
			var share_id = $(this).attr('share_id');
			var fields = $(this).find(':input,:selected').serializeArray();
			var tmpObj = {};
			jQuery.each(fields, function(i, field) {
				tmpObj[field.name] = field.value;
			});
			tmpObj.share_id = share_id;
			tmpObj.last_name = tmpObj.lastName;
			tmpObj.first_name = tmpObj.firstName;
			jsonValues.push(tmpObj);
		});
		return jsonValues;
	};

	this.changeNumShares = changeSharesCount;

	this.toggleContentDivDisplay = function() {
		var d = _d;
		$j('.roomSharesForm').toggle(500);
		return false;
	};

	this.validate = function() {
		return true;
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultRoomSharesWidgetWUID',
	widgetName : 'RoomSharesWidget',
	imgPath : '/resources/img',
	subclass : false,
	numberOfShares : 0,
	roomShareInfo: []
});
